module.exports = __webpack_public_path__ + "img/wenzi.9ebb32cb.png";